import BaseBehavior from '../../../framework/base/base';
import { getCookie } from '../../../shared/utilities/cookies';
import { openWindow } from '../../../shared/utilities/openPopup';

const darkMapStyle = [
	{
		elementType: 'geometry',
		stylers: [
			{
				color: '#212121'
			}
		]
	},
	{
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#757575'
			}
		]
	},
	{
		elementType: 'labels.text.stroke',
		stylers: [
			{
				color: '#212121'
			}
		]
	},
	{
		featureType: 'administrative',
		elementType: 'geometry',
		stylers: [
			{
				color: '#757575'
			},
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'administrative.country',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#9e9e9e'
			}
		]
	},
	{
		featureType: 'administrative.land_parcel',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'administrative.locality',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#bdbdbd'
			}
		]
	},
	{
		featureType: 'administrative.neighborhood',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'poi',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'labels.text',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#757575'
			}
		]
	},
	{
		featureType: 'poi.park',
		elementType: 'geometry',
		stylers: [
			{
				color: '#181818'
			}
		]
	},
	{
		featureType: 'poi.park',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#616161'
			}
		]
	},
	{
		featureType: 'poi.park',
		elementType: 'labels.text.stroke',
		stylers: [
			{
				color: '#1b1b1b'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#2c2c2c'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'labels.text',
		stylers: [
			{
				visibility: 'simplified'
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#8a8a8a'
			}
		]
	},
	{
		featureType: 'road.arterial',
		elementType: 'geometry',
		stylers: [
			{
				color: '#373737'
			}
		]
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry',
		stylers: [
			{
				color: '#3c3c3c'
			}
		]
	},
	{
		featureType: 'road.highway.controlled_access',
		elementType: 'geometry',
		stylers: [
			{
				color: '#4e4e4e'
			}
		]
	},
	{
		featureType: 'road.local',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#616161'
			}
		]
	},
	{
		featureType: 'transit',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'transit',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#757575'
			}
		]
	},
	{
		featureType: 'water',
		elementType: 'geometry',
		stylers: [
			{
				color: '#000000'
			}
		]
	},
	{
		featureType: 'water',
		elementType: 'labels.text',
		stylers: [
			{
				visibility: 'off'
			}
		]
	},
	{
		featureType: 'water',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#3d3d3d'
				// eslint-disable-next-line prettier/prettier
			}
		]
	}
];

const mapStyles = [
	{
		featureType: 'administrative',
		elementType: 'all',
		stylers: [
			{
				visibility: 'on'
			},
			{
				saturation: -100
			},
			{
				lightness: 20
			}
		]
	},
	{
		featureType: 'road',
		elementType: 'all',
		stylers: [
			{
				visibility: 'on'
			},
			{
				saturation: -100
			},
			{
				lightness: 60
			}
		]
	},
	{
		featureType: 'water',
		elementType: 'all',
		stylers: [
			{
				visibility: 'on'
			},
			{
				saturation: 100
			},
			{
				lightness: -30
			}
		]
	},
	{
		featureType: 'landscape.man_made',
		elementType: 'all',
		stylers: [
			{
				visibility: 'simplified'
			},
			{
				saturation: -60
			},
			{
				lightness: 10
			}
		]
	},
	{
		featureType: 'landscape.natural',
		elementType: 'all',
		stylers: [
			{
				visibility: 'simplified'
			},
			{
				saturation: -60
			},
			{
				lightness: 60
			}
		]
	},
	{
		featureType: 'poi',
		elementType: 'all',
		stylers: [
			{
				visibility: 'off'
			},
			{
				saturation: -100
			},
			{
				lightness: 60
			}
		]
	},
	{
		featureType: 'transit',
		elementType: 'all',
		stylers: [
			{
				visibility: 'off'
			},
			{
				saturation: -100
			},
			{
				lightness: 60
			}
		]
	}
];

const markerIcon =
	document.location.protocol +
	'//' +
	document.location.host +
	'/Content/assets/icons/map-marker.svg';

export default class MapComponent extends BaseBehavior {
	constructor(element) {
		super(element);
		this.mapProvider =
			getCookie('iit_ak_geo') === 'CN' && this.element.dataset.amapApiKey ? 'A' : 'G';
		MapComponent.loadMapScript(this);
	}

	static onMapScriptLoad(mapProvider) {
		MapComponent.mapScriptLoaded[mapProvider] = true;
		MapComponent.mapInstances[mapProvider].forEach(instance => instance.initMap());
	}

	static loadMapScript(instance) {
		const { mapProvider } = instance;
		if (MapComponent.mapInstances[mapProvider]) {
			MapComponent.mapInstances[mapProvider].push(instance);
			return;
		}
		MapComponent.mapInstances[mapProvider] = [instance];
		const script = document.createElement('script');
		const initFunctionName = 'initMap' + mapProvider;
		window[initFunctionName] = () => MapComponent.onMapScriptLoad(mapProvider);
		script.src =
			mapProvider === 'G'
				? '//maps.googleapis.com/maps/api/js?key=' +
				  instance.element.dataset.apiKey +
				  '&callback=' +
				  initFunctionName
				: '//webapi.amap.com/maps?v=1.4.9&key=' +
				  instance.element.dataset.amapApiKey +
				  '&callback=' +
				  initFunctionName;
		script.async = true;
		script.defer = true;
		document.body.appendChild(script);
	}

	initMap() {
		if (!MapComponent.mapScriptLoaded[this.mapProvider]) {
			MapComponent.loadMapScript(this);
			return;
		}
		this[`init${this.mapProvider}Map`]();
	}

	initAMap() {
		const center = new window.AMap.LngLat(
			parseFloat(this.element.dataset.lng),
			parseFloat(this.element.dataset.lat)
		);

		this.map = new window.AMap.Map(this.element, {
			center,
			scrollWheel: false,
			zoom: 16
		});

		const marker = new window.AMap.Marker({
			icon: markerIcon,
			position: center,
			map: this.map
		});

		window.AMap.event.addListener(marker, 'click', this.openAMap.bind(this, center));
	}

	initGMap() {
		const center = {
			lat: parseFloat(this.element.dataset.lat),
			lng: parseFloat(this.element.dataset.lng)
		};

		this.map = new window.google.maps.Map(this.element, {
			disableDefaultUI: true,
			draggable: true,
			scrollwheel: false,
			styles: this.element.dataset.theme === 'dark' ? darkMapStyle : mapStyles,
			zoom: 16
		});
		this.map.setCenter(center);
		if (this.element.dataset.marker === 'true') {
			const marker = new window.google.maps.Marker({
				draggable: false,
				icon: {
					anchor: new window.google.maps.Point(30, 30),
					origin: new window.google.maps.Point(0, 0),
					size: new window.google.maps.Size(60, 60),
					url: markerIcon
				},
				map: this.map,
				position: center
			});

			window.google.maps.event.addListener(marker, 'click', this.openGMap.bind(this, center));
		} else {
			this.map.addListener('click', this.openGMap.bind(this, center));
		}
	}

	openAMap(coordinates) {
		this.openMapWindow('//uri.amap.com/marker?position=', [coordinates.lng, coordinates.lat]);
	}

	openGMap(coordinates) {
		this.openMapWindow('//www.google.com/maps/place/', [coordinates.lat, coordinates.lng]);
	}

	openMapWindow(url, coordinatesArr) {
		const urlWithMapCoordinates = url + coordinatesArr[0] + ',' + coordinatesArr[1];
		openWindow(urlWithMapCoordinates, 'map');
	}
}

MapComponent.mapScriptLoaded = {};
MapComponent.mapInstances = {};
